import { DeleteRequest, GetListRequest, GetListResponse } from "./api.model";

export type EventGetListRequest = GetListRequest<EventGetListRequestFilter>;
export type EventGetListResponse = GetListResponse<Event>;
export type EventDeleteRequest = DeleteRequest;

export interface EventGetListRequestFilter {
  /** @format int64 */
  refOrganization_Id?: number | null;

  /** @format int64 */
  refTournament_Id?: number | null;
  code?: string | null;
  name?: string | null;

  /** @format date-time */
  startDate?: string | null;

  /** @format date-time */
  endDate?: string | null;
  checkoutType?: EventCheckOutType;
  bookingType?: EventBookingType;
  bookingFileds?: string | null;
  tags?: string | null;
  isEnabled?: boolean | null;

  /** @format int64 */
  sortOrder?: number | null;
}

export type EventBookingType = 1 | 2;
export type EventCheckOutType = 1 | 2;

export interface Event {
  /** @format int64 */
  refOrganization_Id?: number | null;

  /** @format int64 */
  refTournament_Id?: number | null;
  code?: string | null;
  name?: string | null;

  /** @format date-time */
  startDate?: string | null;

  /** @format date-time */
  endDate?: string | null;
  checkoutType?: EventCheckOutType;
  bookingType?: EventBookingType;
  bookingFileds?: string | null;
  eventCheckoutType_Name?:string|null;
  eventBookingType_Name?:string|null;
  tags?: string | null;
  isEnabled?: boolean | null;

  /** @format int64 */
  sortOrder?: number | null;

  /** @format int64 */
  id?: number;

  /** @format byte */
  system_RowVersion?: string | null;
}

export interface EventInsertRequest {
  /** @format int64 */
  refOrganization_Id?: number | null;

  /** @format int64 */
  refTournament_Id?: number | null;
  code?: string | null;
  name?: string | null;

  /** @format date-time */
  startDate?: string | null;

  /** @format date-time */
  endDate?: string | null;
  checkoutType?: EventCheckOutType;
  bookingType?: EventBookingType;
  bookingFileds?: string | null;
  tags?: string | null;
  isEnabled?: boolean | null;

  /** @format int64 */
  sortOrder?: number | null;
  event_Translations: EventTranslationInsertRequest[];
}

export interface EventTranslationInsertRequest {
  translation?: string | null;
  name?: string | null;
  description?: string | null;
  tags?: string | null;

  /** @format int64 */
  refLanguage_Id?: number | null;
  isEnabled?: boolean | null;
}
